import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import type { UnitPromotion } from "@/types";
import { WidgetLayout } from "@/types/enums";

interface UnitPromotionsProps {
    promotions: UnitPromotion[];
    selectedPromo: number;
    onPromoChange: (promo: number) => void;
    widgetLayout?: WidgetLayout;
}

// Pure component that always requires props
export const UnitPromotions = ({
    promotions,
    selectedPromo,
    onPromoChange,
    widgetLayout,
}: UnitPromotionsProps) => {
    const isLayout2 = widgetLayout === WidgetLayout.LAYOUT_2;
    // Market layout (WEB-704) mirrors Layout 2's multi-promo presentation: the
    // SALE ribbon on the card + promo selection inside the expandable row.
    const isMarket = widgetLayout === WidgetLayout.MARKET;

    if (promotions.length === 1) {
        return (
            <span className="unit-item-promotion">
                {promotions[0]!.name}
            </span>
        );
    }

    if (promotions.length > 1) {
        // Layout 2 / market: show "SALE" ribbon; promo selection is in the
        // expandable row. The --sale modifier lets the market template render
        // the jagged yellow SALE tag from the mockup (single/named promos stay
        // the rounded chip).
        if (isLayout2 || isMarket) {
            return (
                <span className="unit-item-promotion unit-item-promotion--sale">
                    SALE
                </span>
            );
        }

        // Layout 1: show Select dropdown
        return (
            <Select
                value={selectedPromo.toString()}
                onValueChange={(value) => onPromoChange(Number(value))}
            >
                <SelectTrigger
                    className="unit-item-promotions tw:max-w-[280px] tw:h-auto tw:min-h-9 tw:whitespace-normal tw:[&>span]:line-clamp-none tw:[&>svg]:shrink-0"
                    title="Unit Promotion"
                >
                    <SelectValue placeholder="Select a promotion" />
                </SelectTrigger>
                <SelectContent className="se-unit-table se-unit-table-promotions tw:z-max">
                    {promotions.map((promo) => (
                        <SelectItem
                            key={promo.id.toString()}
                            value={promo.id.toString()}
                        >
                            <span className="tw:font-bold">{promo.name}</span>
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        );
    }

    return null;
};
